import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import TrackingLink from 'Layout/NavBar/MegaMenu/Categories/TrackingLink';

export default function PlayStylesLinks({ setMegaMenuTab }) {
  return (
    <ul className="CategoriesMegaMenu__linksContainer" role="menu">
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--title">
        <Link to="/categories" id="categories-playstyles" onClick={() => setMegaMenuTab('')}>
          <FormattedMessage id="play-styles-links.link.play-styles" defaultMessage="Play Styles" />
        </Link>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/co-op" id="categories-coop" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="play-styles-links.link.co-op" defaultMessage="Co-op" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/multiplayer" id="categories-multiplayer" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="play-styles-links.link.multiplayer" defaultMessage="Multiplayer" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/open-world" id="categories-openworld" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="play-styles-links.link.open-world" defaultMessage="Open World" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/pvp" id="categories-pvp" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="play-styles-links.link.pvp" defaultMessage="PvP" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/singleplayer" id="categories-singleplayer" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="play-styles-links.link.singleplayer" defaultMessage="Singleplayer" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/turn-based" id="categories-turnbased" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="play-styles-links.link.turn-based" defaultMessage="Turn-Based" />
        </TrackingLink>
      </li>
    </ul>
  );
}

PlayStylesLinks.propTypes = {
  setMegaMenuTab: PropTypes.func,
};

PlayStylesLinks.defaultProps = {
  setMegaMenuTab: () => { },
};
